import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import MenuSection from "../components/MenuSection";
import PositionButton from "../components/PositionButton";
import { useProductStore } from "../hooks/useProductStore";

export const SeleccionIslaPage = () => {
  const navigate = useNavigate();
  const { addProducto, idProductoArray } = useProductStore();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 700);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 700);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const posiciones = [
    { n: 1, enabled: true },
    { n: 2, enabled: true },
    { n: 3, enabled: false },
    { n: 4, enabled: false },
    { n: 5, enabled: true },
    { n: 6, enabled: true },
    { n: 7, enabled: false },
    { n: 8, enabled: false },
  ];

  const handlePositionClick = positionNumber => {
    try {
      const autoservicioData = localStorage.getItem("autoservicioSelection");
      if (!autoservicioData) {
        console.error("No autoservicioSelection data found in localStorage");
        navigate(`/posicion/${positionNumber}`);
        return;
      }

      const selection = JSON.parse(autoservicioData);

      let litros = 0;
      let importe = 0;
      let precioUnitario = 1358;

      if (selection.unit === "LITROS") {
        litros = selection.amount;
        importe = selection.amount * precioUnitario;
      } else {
        importe = selection.amount;
        litros = importe / precioUnitario;
      }

      const productData = {
        idProductoArray: idProductoArray,
        descripcion: selection.fuel || "Combustible",
        litros: litros,
        importe: parseFloat(importe),
        idArticulo: 293,
        producto: selection.fuel || "Combustible",
        precio: precioUnitario,
        precioPublico: precioUnitario,
        cantidad: litros,
        esDespacho: true,
        esCombustible: true,
        posicion: positionNumber,
        fecha: new Date().toISOString(),
        surtidor: "Autoservicio",
        manguera: "1",
      };

      addProducto(productData);

      navigate("/dashboard");
    } catch (error) {
      console.error("Error processing autoservicioSelection:", error);
    }
  };

  return (
    <>
      <MenuSection />
      <Box sx={{ maxWidth: 380, mx: "auto", mt: 3, ...(!isMobile && { transform: "scale(0.8)" }) }}>
        {posiciones.map(({ n, enabled }, idx) => (
          <Box key={n}>
            <PositionButton number={n} enabled={enabled} onClick={() => enabled && handlePositionClick(n)} />

            {idx % 2 === 0 && idx < posiciones.length - 1 && (
              <Box
                sx={{
                  height: 4,
                  bgcolor: "#003E7E",
                  ml: "0px",
                  mr: 0,
                  my: 0.7,
                  borderRadius: 2,
                }}
              />
            )}

            {idx % 2 === 1 && idx < posiciones.length - 1 && <Box sx={{ height: 26 }} />}
          </Box>
        ))}
      </Box>
    </>
  );
};
